'use client'

import dynamic from 'next/dynamic'
import { useEffect } from 'react'
import rybbit from '@rybbit/js'


// Dynamically load analytics to avoid blocking initial load
const DynamicAnalytics = dynamic(() => import('@vercel/analytics/react').then(mod => ({ default: mod.Analytics })), {
  ssr: false,
  loading: () => null,
});

const DynamicSpeedInsights = dynamic(() => import('@vercel/speed-insights/next').then(mod => ({ default: mod.SpeedInsights })), {
  ssr: false,
  loading: () => null,
});

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // TEMPORARILY DISABLED: Rybbit analytics causing 6GB memory spike on Railway
    // Re-enable after configuring ClickHouse memory limits
    if (process.env.NODE_ENV === 'development') {
      console.log('Rybbit analytics disabled due to memory issues')
    }

    // const siteId = '1'
    // try {
    //   rybbit.init({
    //     analyticsHost: '/rybbit',
    //     siteId,
    //     autoTrackPageviews: false,
    //     autoTrackSpaRoutes: false,
    //     trackOutboundLinks: false,
    //     trackDataAttributes: false,
    //     trackWebVitals: true,
    //   })
    // } catch (e) {
    //   if (process.env.NODE_ENV !== 'production') console.warn('Rybbit init skipped:', e)
    // }
    // return () => {
    //   try { rybbit.cleanup() } catch {}
    // }
  }, [])

  return (
    <>
      {children}
      <DynamicAnalytics />
      <DynamicSpeedInsights />
    </>
  )
}